import { z } from 'zod';

export const SSubscribeToTopicsRequest = z.object({
  topics: z.string().array(),
  device_token: z.string(),
});
export type TSubscribeToTopicsRequest = z.infer<
  typeof SSubscribeToTopicsRequest
>;
